import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'

import { Button, Close3Icon, LightningIcon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { mediaMaxDesktopSmall } from '@root/shared/ui-kit'
import {
  instantTradeDialogPositionAtom,
  instantTradeDialogVisibleAtom,
  toggleInstantTradeDialogAction,
} from '@root/widgets/instant-trade-dialog/atoms'
import { INSTANT_TRADE_DIALOG_DIMENSIONS } from '@root/widgets/instant-trade-dialog/constants'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const TradeTablesActionsTrade: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()

  const instantTradeRef = useRef<HTMLButtonElement>(null)

  const [position, setPosition] = useAtom(instantTradeDialogPositionAtom)
  const [isInstantTradeDialogVisible] = useAtom(instantTradeDialogVisibleAtom)
  const toggleInstantTradeDialog = useAction(toggleInstantTradeDialogAction)

  useEffect(() => {
    const element = instantTradeRef.current
    const isNotPositioned = element && !position

    // if not positioned set position from button
    if (isNotPositioned) {
      const rect = element.getBoundingClientRect()
      const x = rect.x - INSTANT_TRADE_DIALOG_DIMENSIONS.width / 2
      const y = rect.y - 250

      setPosition({ x, y })
    }
  }, [instantTradeRef, setPosition, position])

  const IconInstantTrade = isInstantTradeDialogVisible
    ? Close3Icon
    : LightningIcon

  return (
    <Root
      onClick={toggleInstantTradeDialog}
      ref={instantTradeRef}
      className={className}
      radius="rounded"
      aria-checked={!!isInstantTradeDialogVisible}
    >
      <IconInstantTrade size={10} />
      <Text>{t('trade.instant-trade')}</Text>
    </Root>
  )
}

const Root = styled(Button)`
  --button-radius-rounded: 6px;

  border: 1px solid transparent;
  background: var(--primaryA-3);
  color: var(--primary-10);

  height: 20px;
  padding-inline: 8px;

  font-size: 11px;
  font-weight: 600;

  &:hover {
    background: var(--primaryA-4);
    color: var(--primary-11);
  }

  &[aria-checked='true'] {
    border: 1px solid var(--primaryA-5);
    background: transparent;
  }
`
const Text = styled.span`
  ${mediaMaxDesktopSmall(css`
    display: none;
  `)}
`
